/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RestorePasswordDto model module.
 * @module model/RestorePasswordDto
 * @version v0
 */
class RestorePasswordDto {
    /**
     * Constructs a new <code>RestorePasswordDto</code>.
     * @alias module:model/RestorePasswordDto
     * @param status {Boolean} 
     * @param message {String} 
     */
    constructor(status, message) { 
        
        RestorePasswordDto.initialize(this, status, message);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, status, message) { 
        obj['status'] = status;
        obj['message'] = message;
    }

    /**
     * Constructs a <code>RestorePasswordDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RestorePasswordDto} obj Optional instance to populate.
     * @return {module:model/RestorePasswordDto} The populated <code>RestorePasswordDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RestorePasswordDto();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Boolean');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RestorePasswordDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RestorePasswordDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of RestorePasswordDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }

        return true;
    }


}

RestorePasswordDto.RequiredProperties = ["status", "message"];

/**
 * @member {Boolean} status
 */
RestorePasswordDto.prototype['status'] = undefined;

/**
 * @member {String} message
 */
RestorePasswordDto.prototype['message'] = undefined;






export default RestorePasswordDto;

